import React, { useEffect, useState } from 'react';
import api from '../api';
import Layout from '../components/Layout';

export default function Admins() {
  const [admins, setAdmins] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ nome:'', email:'', nivel:'master' });
  const [msg, setMsg] = useState('');

  const carregar = () => api.get('/admins').then(r => setAdmins(r.data)).catch(() => {});
  useEffect(() => { carregar(); }, []);

  const salvar = async () => {
    try {
      if (modal === 'novo') await api.post('/admins', form);
      else await api.put('/admins/' + modal.id, form);
      setMsg('Salvo com sucesso!'); setModal(null); carregar();
    } catch(e) { setMsg(e.response?.data?.erro || 'Erro'); }
  };

  const resetSenha = async (id) => {
    if (!window.confirm('Resetar senha deste administrador?')) return;
    try {
      await api.post('/admins/' + id + '/reset-senha', { motivo:'Reset pelo painel' });
      setMsg('Senha resetada e enviada por e-mail!');
    } catch(e) { setMsg('Erro ao resetar'); }
  };

  const desativar = async (id) => {
    if (!window.confirm('Desativar este administrador?')) return;
    try { await api.delete('/admins/' + id); carregar(); setMsg('Desativado!'); }
    catch(e) { setMsg('Erro'); }
  };

  return (
    <Layout title="Administradores">
      {msg && <div style={s.msg}>{msg} <button onClick={() => setMsg('')} style={s.close}>x</button></div>}
      <div style={s.bar}>
        <p style={s.desc}>Administradores têm acesso total à plataforma, sem vínculo com partido.</p>
        <button style={s.btn} onClick={() => { setForm({nome:'',email:'',nivel:'master'}); setModal('novo'); }}>+ Novo administrador</button>
      </div>
      <div style={s.table}>
        <div style={s.thead}>
          <span>Nome</span><span>E-mail</span><span>Nível</span><span>Status</span><span>Ações</span>
        </div>
        {admins.map(a => (
          <div key={a.id} style={s.row}>
            <span style={s.name}>{a.nome}</span>
            <span style={s.email}>{a.email}</span>
            <span><span style={s.badge}>{a.nivel}</span></span>
            <span><span style={{...s.status, background: a.ativo ? '#EAF3DE' : '#FCEBEB', color: a.ativo ? '#3B6D11' : '#A32D2D'}}>{a.ativo ? 'Ativo' : 'Inativo'}</span></span>
            <span style={s.actions}>
              <button style={s.abtn} onClick={() => { setForm({nome:a.nome,email:a.email,nivel:a.nivel}); setModal(a); }}>Editar</button>
              <button style={s.abtn} onClick={() => resetSenha(a.id)}>Senha</button>
              <button style={{...s.abtn, color:'#e74c3c'}} onClick={() => desativar(a.id)}>Desativar</button>
            </span>
          </div>
        ))}
      </div>
      {modal && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <h3 style={s.mtitle}>{modal === 'novo' ? 'Novo administrador' : 'Editar administrador'}</h3>
            <div style={s.field}><label>Nome</label><input style={s.input} value={form.nome} onChange={e => setForm({...form, nome:e.target.value})} /></div>
            <div style={s.field}><label>E-mail</label><input style={s.input} type="email" value={form.email} onChange={e => setForm({...form, email:e.target.value})} /></div>
            <div style={s.field}><label>Nível</label>
              <select style={s.input} value={form.nivel} onChange={e => setForm({...form, nivel:e.target.value})}>
                <option value="master">Master</option>
                <option value="leitura">Somente leitura</option>
              </select>
            </div>
            <div style={s.mfoot}>
              <button style={s.cbtn} onClick={() => setModal(null)}>Cancelar</button>
              <button style={s.btn} onClick={salvar}>Salvar</button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

const s = {
  msg:{background:'#EAF3DE',color:'#3B6D11',padding:'10px 16px',borderRadius:8,marginBottom:16,display:'flex',justifyContent:'space-between'},
  close:{background:'none',border:'none',cursor:'pointer',fontSize:18},
  bar:{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20},
  desc:{fontSize:13,color:'#666',margin:0},
  btn:{background:'#534AB7',color:'#fff',border:'none',borderRadius:8,padding:'9px 18px',fontSize:13,fontWeight:600,cursor:'pointer'},
  table:{background:'#fff',borderRadius:12,overflow:'hidden',boxShadow:'0 1px 4px rgba(0,0,0,0.06)'},
  thead:{display:'grid',gridTemplateColumns:'1.5fr 2fr 1fr 1fr 1.5fr',padding:'12px 20px',background:'#f8f9fa',fontSize:12,fontWeight:600,color:'#888',gap:8},
  row:{display:'grid',gridTemplateColumns:'1.5fr 2fr 1fr 1fr 1.5fr',padding:'14px 20px',borderTop:'1px solid #f0f0f0',alignItems:'center',gap:8,fontSize:13},
  name:{fontWeight:500,color:'#1a1a2e'},
  email:{color:'#666'},
  badge:{background:'#EEEDFE',color:'#3C3489',padding:'2px 8px',borderRadius:20,fontSize:11,fontWeight:500},
  status:{padding:'2px 8px',borderRadius:20,fontSize:11,fontWeight:500},
  actions:{display:'flex',gap:6},
  abtn:{background:'none',border:'1px solid #eee',borderRadius:6,padding:'4px 8px',cursor:'pointer',fontSize:12},
  overlay:{position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:100},
  modal:{background:'#fff',borderRadius:16,padding:28,width:380},
  mtitle:{margin:'0 0 20px',fontSize:16,fontWeight:600},
  field:{display:'flex',flexDirection:'column',gap:6,marginBottom:14},
  input:{padding:'9px 12px',border:'1px solid #ddd',borderRadius:8,fontSize:13},
  mfoot:{display:'flex',justifyContent:'flex-end',gap:10,marginTop:20},
  cbtn:{background:'#f0f0f0',border:'none',borderRadius:8,padding:'9px 18px',fontSize:13,cursor:'pointer'},
};
